/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddAssignmentRequest } from '../api-models';
// @ts-ignore
import { AddAssignmentRequestV2 } from '../api-models';
// @ts-ignore
import { AllocatedEmployeeAndAbsencesResponse } from '../api-models';
// @ts-ignore
import { AssignSelectedOpenshiftsRequest } from '../api-models';
// @ts-ignore
import { AvailableEmployeesOrderBy } from '../api-models';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfDailyViewResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfDictionaryOfAssignmentIntegrationErrorsAndListOfAssignmentIntegrationStatus } from '../api-models';
// @ts-ignore
import { BaseResponseOfDictionaryOfInt64AndListOfAllocatedEmployeListResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfAllocatedEmployeListResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfGetPositionDetailsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfSchedulePositionResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewAbsenceDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewDailyStaffingLevelsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfListOfAllocatedEmployeListResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfPageModelOfGetAvailableEmployeesByPositionAndDatesResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewAbsenceDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewAssignmentDto } from '../api-models';
// @ts-ignore
import { BudgetsByOpening } from '../api-models';
// @ts-ignore
import { CreateAbsenceDto } from '../api-models';
// @ts-ignore
import { CreateAssignmentDto } from '../api-models';
// @ts-ignore
import { DailyViewStartDateResponse } from '../api-models';
// @ts-ignore
import { DailyViewSummaryResponse } from '../api-models';
// @ts-ignore
import { DeletePlannedAbsenceResponse } from '../api-models';
// @ts-ignore
import { EmployeeCentricBudgetTableShiftType } from '../api-models';
// @ts-ignore
import { EmployeeCentricViewResponse } from '../api-models';
// @ts-ignore
import { EmployerType } from '../api-models';
// @ts-ignore
import { GetAvailableSchedulesRequest } from '../api-models';
// @ts-ignore
import { LogEntry } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ScheduleCalendarAbsencesResponse } from '../api-models';
// @ts-ignore
import { ScheduleCalendarGroupBy } from '../api-models';
// @ts-ignore
import { ScheduleCalendarRequest } from '../api-models';
// @ts-ignore
import { ScheduleCalendarResponse } from '../api-models';
// @ts-ignore
import { ScheduleStatusTypeResponse } from '../api-models';
// @ts-ignore
import { SchedulerOvertimeType } from '../api-models';
// @ts-ignore
import { UpdateAssignmentDto } from '../api-models';
// @ts-ignore
import { ViewAssignmentDto } from '../api-models';
// @ts-ignore
import { WeeklyView } from '../api-models';
/**
 * ManageSchedulesApi - axios parameter creator
 * @export
 */
export const ManageSchedulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This should be removed once front end calls the replacement: Absences/AbsenceReasons/Scheduler.  Just need to wait until the newer one is published in order to modify the front end.
         * @summary Gets absence reasons for the scheduler (original endpoint).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAbsenceReasonsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/absence-reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddAssignmentRequest} [addAssignmentRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsAddAssignmentPost: async (addAssignmentRequest?: AddAssignmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/add-assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. The lists a manager picks  from already exclude those employees, so this fires on a direct call or a page loaded before  a work pattern changed. SPD-5838 covers surfacing it.
         * @param {CreateAssignmentDto} [createAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignEmployeePost: async (createAssignmentDto?: CreateAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/assign-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. SPD-5838 covers surfacing  it.    Unlike the sibling actions, this one IS reachable from the screen rather than only from a  direct call or a stale page. Find Staff\'s tabs exclude these employees, but the website\'s  Open Shifts page lists its own through `GET OpenShift/posted-shift-employees`  (`OpeningService.GetOpenShiftEmployeesWithOpeningTemplates`), which applies no work  pattern test — so anyone auto-post notified BEFORE this release while on Simple Scheduling  or with no pattern still shows there as Notified, and ticking one refuses the whole  selection. Auto-post adds nobody new to that group from release, so it only shrinks.  Not filtered there: the query joins two keyless views, so no test can reach the predicate.
         * @param {AssignSelectedOpenshiftsRequest} [assignSelectedOpenshiftsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignOpenshiftsPost: async (assignSelectedOpenshiftsRequest?: AssignSelectedOpenshiftsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/assign-openshifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignSelectedOpenshiftsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [openingTemplateId] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignedEmployeeGet: async (openingTemplateId?: number, openingTemplateDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/assigned-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (openingTemplateId !== undefined) {
                localVarQueryParameter['openingTemplateId'] = openingTemplateId;
            }

            if (openingTemplateDate !== undefined) {
                localVarQueryParameter['openingTemplateDate'] = openingTemplateDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assignmentId 
         * @param {CreateAbsenceDto} [createAbsenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdDelete: async (assignmentId: number, createAbsenceDto?: CreateAbsenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsAssignmentIdDelete', 'assignmentId', assignmentId)
            const localVarPath = `/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAbsenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Use v2/{assignmentId}
         * @param {number} assignmentId 
         * @param {UpdateAssignmentDto} [updateAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdPut: async (assignmentId: number, updateAssignmentDto?: UpdateAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsAssignmentIdPut', 'assignmentId', assignmentId)
            const localVarPath = `/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {string} date 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDailyviewGet: async (departmentId: number, date: string, facilityId?: number, positionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('assignmentsDailyviewGet', 'departmentId', departmentId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('assignmentsDailyviewGet', 'date', date)
            const localVarPath = `/assignments/dailyview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDailyviewSummaryGet: async (departmentId?: number, facilityId?: number, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/dailyview-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDefectiveOpeningInstanceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/defective-opening-instance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDateTime 
         * @param {string} endDateTime 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDisplaySchedulesGet: async (startDateTime: string, endDateTime: string, departmentId?: number, facilityId?: number, positionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDateTime' is not null or undefined
            assertParamExists('assignmentsDisplaySchedulesGet', 'startDateTime', startDateTime)
            // verify required parameter 'endDateTime' is not null or undefined
            assertParamExists('assignmentsDisplaySchedulesGet', 'endDateTime', endDateTime)
            const localVarPath = `/assignments/display-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }

            if (startDateTime !== undefined) {
                localVarQueryParameter['startDateTime'] = (startDateTime as any instanceof Date) ?
                    (startDateTime as any).toISOString() :
                    startDateTime;
            }

            if (endDateTime !== undefined) {
                localVarQueryParameter['endDateTime'] = (endDateTime as any instanceof Date) ?
                    (endDateTime as any).toISOString() :
                    endDateTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAvailableSchedulesRequest} [getAvailableSchedulesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDisplaySchedulesPost: async (getAvailableSchedulesRequest?: GetAvailableSchedulesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/display-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAvailableSchedulesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} absenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsenceAbsenceIdDelete: async (absenceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('assignmentsEmployeeAbsenceAbsenceIdDelete', 'absenceId', absenceId)
            const localVarPath = `/assignments/employee/absence/{absenceId}`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} absenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsencePlannedAbsenceIdDelete: async (absenceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('assignmentsEmployeeAbsencePlannedAbsenceIdDelete', 'absenceId', absenceId)
            const localVarPath = `/assignments/employee/absence/planned/{absenceId}`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsencePlannedGet: async (employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/employee/absence/planned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAbsenceDto} [createAbsenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsencePlannedPost: async (createAbsenceDto?: CreateAbsenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/employee/absence/planned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAbsenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {string} [search] 
         * @param {number} [schedulePeriodId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [weekNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsEmployeeScheduleGet: async (departmentId?: number, facilityId?: number, positionIds?: Array<number>, search?: string, schedulePeriodId?: number, page?: number, pageSize?: number, weekNumber?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/employee-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (weekNumber !== undefined) {
                localVarQueryParameter['weekNumber'] = weekNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [schedulePeriodId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeTotalBudgetsGet: async (departmentId?: number, facilityId?: number, schedulePeriodId?: number, positionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/employee-total-budgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsIntegrationRetriesGet: async (days?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/integration-retries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsIntegrationStatusGet: async (startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/integration-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {string} [startDateTime] 
         * @param {string} [endDateTime] 
         * @param {string} [searchParam] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<EmployerType>} [employerType] 
         * @param {Array<SchedulerOvertimeType>} [overTime] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {number} [openingTemplateId] 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsInterestedEmployeeGet: async (positionId?: number, startDateTime?: string, endDateTime?: string, searchParam?: string, page?: number, pageSize?: number, employerType?: Array<EmployerType>, overTime?: Array<SchedulerOvertimeType>, orderBy?: AvailableEmployeesOrderBy, openingTemplateId?: number, facilityId?: number, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/interested-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (startDateTime !== undefined) {
                localVarQueryParameter['startDateTime'] = (startDateTime as any instanceof Date) ?
                    (startDateTime as any).toISOString() :
                    startDateTime;
            }

            if (endDateTime !== undefined) {
                localVarQueryParameter['endDateTime'] = (endDateTime as any instanceof Date) ?
                    (endDateTime as any).toISOString() :
                    endDateTime;
            }

            if (searchParam !== undefined) {
                localVarQueryParameter['searchParam'] = searchParam;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (employerType) {
                localVarQueryParameter['employerType'] = employerType;
            }

            if (overTime) {
                localVarQueryParameter['overTime'] = overTime;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (openingTemplateId !== undefined) {
                localVarQueryParameter['openingTemplateId'] = openingTemplateId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {string} [startDateTime] 
         * @param {string} [endDateTime] 
         * @param {string} [searchParam] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<EmployerType>} [employerType] 
         * @param {Array<SchedulerOvertimeType>} [overTime] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {number} [openingTemplateId] 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsNotifiedEmployeeGet: async (positionId?: number, startDateTime?: string, endDateTime?: string, searchParam?: string, page?: number, pageSize?: number, employerType?: Array<EmployerType>, overTime?: Array<SchedulerOvertimeType>, orderBy?: AvailableEmployeesOrderBy, openingTemplateId?: number, facilityId?: number, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/notified-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (startDateTime !== undefined) {
                localVarQueryParameter['startDateTime'] = (startDateTime as any instanceof Date) ?
                    (startDateTime as any).toISOString() :
                    startDateTime;
            }

            if (endDateTime !== undefined) {
                localVarQueryParameter['endDateTime'] = (endDateTime as any instanceof Date) ?
                    (endDateTime as any).toISOString() :
                    endDateTime;
            }

            if (searchParam !== undefined) {
                localVarQueryParameter['searchParam'] = searchParam;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (employerType) {
                localVarQueryParameter['employerType'] = employerType;
            }

            if (overTime) {
                localVarQueryParameter['overTime'] = overTime;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (openingTemplateId !== undefined) {
                localVarQueryParameter['openingTemplateId'] = openingTemplateId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsPositionDetailsGet: async (departmentId?: number, positionId?: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/positionDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsRetryIntegrationAssignmentIdGet: async (assignmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsRetryIntegrationAssignmentIdGet', 'assignmentId', assignmentId)
            const localVarPath = `/assignments/retry-integration/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsRetryIntegrationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/retry-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsScheduleCalendarAbsencesGet: async (schedulePeriodId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/schedule-calendar-absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {ScheduleCalendarGroupBy} [groupBy] 
         * @param {number} [shiftTypeId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsScheduleCalendarGet: async (schedulePeriodId?: number, groupBy?: ScheduleCalendarGroupBy, shiftTypeId?: number, facilityId?: number, positionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/schedule-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['groupBy'] = groupBy;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ScheduleCalendarRequest} [scheduleCalendarRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsScheduleCalendarPost: async (scheduleCalendarRequest?: ScheduleCalendarRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/schedule-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleCalendarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsSchedulerViewsStartDateGet: async (departmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('assignmentsSchedulerViewsStartDateGet', 'departmentId', departmentId)
            const localVarPath = `/assignments/scheduler-views-start-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [schedulePeriodId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsShiftBudgetsPerEmployeeScheduleGet: async (departmentId?: number, facilityId?: number, schedulePeriodId?: number, positionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/shift-budgets-per-employee-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   This endpoint intentionally does <b>not</b> accept or flow a System.Threading.CancellationToken              to the transactional work. The transaction is executed with System.Threading.CancellationToken.None to avoid              partial execution if the HTTP request is aborted (e.g., client disconnect). Once started, the core write              operation is allowed to complete deterministically.    Post-create operations are executed asynchronously via Hangfire using the authenticated facility context              (OpenShifts.WebApi.Controllers.Scheduler.BaseController.FacilityId), and therefore are decoupled from the HTTP request lifecycle.
         * @summary Creates a new employee assignment (v2) within a single database transaction, then enqueues  post-create processing as a Hangfire background job.
         * @param {AddAssignmentRequestV2} [addAssignmentRequestV2] The assignment creation request payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2AddAssignmentPost: async (addAssignmentRequestV2?: AddAssignmentRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/v2/add-assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAssignmentRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get assignments along with empty assignments for empty split assignment slots
         * @param {number} [openingTemplateId] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsV2AssignedEmployeeGet: async (openingTemplateId?: number, openingTemplateDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/v2/assigned-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (openingTemplateId !== undefined) {
                localVarQueryParameter['openingTemplateId'] = openingTemplateId;
            }

            if (openingTemplateDate !== undefined) {
                localVarQueryParameter['openingTemplateDate'] = openingTemplateDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Same as \"v2/assigned-employee\" or \"v3/assigned-employee\" but retrieves data for multiple opening templates
         * @param {Array<number>} [openingTemplateIds] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2AssignedEmployeeMultipleShiftsGet: async (openingTemplateIds?: Array<number>, openingTemplateDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/v2/assigned-employee-multiple-shifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (openingTemplateIds) {
                localVarQueryParameter['openingTemplateIds'] = openingTemplateIds;
            }

            if (openingTemplateDate !== undefined) {
                localVarQueryParameter['openingTemplateDate'] = openingTemplateDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assignmentId 
         * @param {UpdateAssignmentDto} [updateAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2AssignmentIdPut: async (assignmentId: number, updateAssignmentDto?: UpdateAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsV2AssignmentIdPut', 'assignmentId', assignmentId)
            const localVarPath = `/assignments/v2/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [unitIds] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2DailyviewGet: async (date: string, departmentId?: number, facilityId?: number, unitIds?: Array<number>, positionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('assignmentsV2DailyviewGet', 'date', date)
            const localVarPath = `/assignments/v2/dailyview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (unitIds) {
                localVarQueryParameter['unitIds'] = unitIds;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {string} [search] 
         * @param {number} [schedulePeriodId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [weekNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2EmployeeScheduleGet: async (departmentId?: number, facilityId?: number, positionIds?: Array<number>, search?: string, schedulePeriodId?: number, page?: number, pageSize?: number, weekNumber?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/v2/employee-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (weekNumber !== undefined) {
                localVarQueryParameter['weekNumber'] = weekNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get assignments along with empty assignments for empty split assignment slots along with placeholders
         * @param {number} [openingTemplateId] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV3AssignedEmployeeGet: async (openingTemplateId?: number, openingTemplateDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/v3/assigned-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (openingTemplateId !== undefined) {
                localVarQueryParameter['openingTemplateId'] = openingTemplateId;
            }

            if (openingTemplateDate !== undefined) {
                localVarQueryParameter['openingTemplateDate'] = openingTemplateDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {string} [startDateTime] 
         * @param {string} [endDateTime] 
         * @param {string} [searchParam] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<EmployerType>} [employerType] 
         * @param {Array<SchedulerOvertimeType>} [overTime] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {number} [openingTemplateId] 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV3AvailableEmployeeGet: async (positionId?: number, startDateTime?: string, endDateTime?: string, searchParam?: string, page?: number, pageSize?: number, employerType?: Array<EmployerType>, overTime?: Array<SchedulerOvertimeType>, orderBy?: AvailableEmployeesOrderBy, openingTemplateId?: number, facilityId?: number, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments/v3/available-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (startDateTime !== undefined) {
                localVarQueryParameter['startDateTime'] = (startDateTime as any instanceof Date) ?
                    (startDateTime as any).toISOString() :
                    startDateTime;
            }

            if (endDateTime !== undefined) {
                localVarQueryParameter['endDateTime'] = (endDateTime as any instanceof Date) ?
                    (endDateTime as any).toISOString() :
                    endDateTime;
            }

            if (searchParam !== undefined) {
                localVarQueryParameter['searchParam'] = searchParam;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (employerType) {
                localVarQueryParameter['employerType'] = employerType;
            }

            if (overTime) {
                localVarQueryParameter['overTime'] = overTime;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (openingTemplateId !== undefined) {
                localVarQueryParameter['openingTemplateId'] = openingTemplateId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageSchedulesApi - functional programming interface
 * @export
 */
export const ManageSchedulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManageSchedulesApiAxiosParamCreator(configuration)
    return {
        /**
         * This should be removed once front end calls the replacement: Absences/AbsenceReasons/Scheduler.  Just need to wait until the newer one is published in order to modify the front end.
         * @summary Gets absence reasons for the scheduler (original endpoint).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAbsenceReasonsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleStatusTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAbsenceReasonsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddAssignmentRequest} [addAssignmentRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignmentsAddAssignmentPost(addAssignmentRequest?: AddAssignmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAddAssignmentPost(addAssignmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. The lists a manager picks  from already exclude those employees, so this fires on a direct call or a page loaded before  a work pattern changed. SPD-5838 covers surfacing it.
         * @param {CreateAssignmentDto} [createAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignEmployeePost(createAssignmentDto?: CreateAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignEmployeePost(createAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. SPD-5838 covers surfacing  it.    Unlike the sibling actions, this one IS reachable from the screen rather than only from a  direct call or a stale page. Find Staff\'s tabs exclude these employees, but the website\'s  Open Shifts page lists its own through `GET OpenShift/posted-shift-employees`  (`OpeningService.GetOpenShiftEmployeesWithOpeningTemplates`), which applies no work  pattern test — so anyone auto-post notified BEFORE this release while on Simple Scheduling  or with no pattern still shows there as Notified, and ticking one refuses the whole  selection. Auto-post adds nobody new to that group from release, so it only shrinks.  Not filtered there: the query joins two keyless views, so no test can reach the predicate.
         * @param {AssignSelectedOpenshiftsRequest} [assignSelectedOpenshiftsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignOpenshiftsPost(assignSelectedOpenshiftsRequest?: AssignSelectedOpenshiftsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignOpenshiftsPost(assignSelectedOpenshiftsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [openingTemplateId] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignedEmployeeGet(openingTemplateId?: number, openingTemplateDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfAllocatedEmployeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignedEmployeeGet(openingTemplateId, openingTemplateDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} assignmentId 
         * @param {CreateAbsenceDto} [createAbsenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignmentIdDelete(assignmentId: number, createAbsenceDto?: CreateAbsenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdDelete(assignmentId, createAbsenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Use v2/{assignmentId}
         * @param {number} assignmentId 
         * @param {UpdateAssignmentDto} [updateAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignmentsAssignmentIdPut(assignmentId: number, updateAssignmentDto?: UpdateAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdPut(assignmentId, updateAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {string} date 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsDailyviewGet(departmentId: number, date: string, facilityId?: number, positionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfDailyViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsDailyviewGet(departmentId, date, facilityId, positionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsDailyviewSummaryGet(departmentId?: number, facilityId?: number, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyViewSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsDailyviewSummaryGet(departmentId, facilityId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsDefectiveOpeningInstanceGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsDefectiveOpeningInstanceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDateTime 
         * @param {string} endDateTime 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsDisplaySchedulesGet(startDateTime: string, endDateTime: string, departmentId?: number, facilityId?: number, positionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfSchedulePositionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsDisplaySchedulesGet(startDateTime, endDateTime, departmentId, facilityId, positionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAvailableSchedulesRequest} [getAvailableSchedulesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsDisplaySchedulesPost(getAvailableSchedulesRequest?: GetAvailableSchedulesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfSchedulePositionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsDisplaySchedulesPost(getAvailableSchedulesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} absenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsEmployeeAbsenceAbsenceIdDelete(absenceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsEmployeeAbsenceAbsenceIdDelete(absenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} absenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsEmployeeAbsencePlannedAbsenceIdDelete(absenceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletePlannedAbsenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsEmployeeAbsencePlannedAbsenceIdDelete(absenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsEmployeeAbsencePlannedGet(employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsEmployeeAbsencePlannedGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateAbsenceDto} [createAbsenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsEmployeeAbsencePlannedPost(createAbsenceDto?: CreateAbsenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsEmployeeAbsencePlannedPost(createAbsenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {string} [search] 
         * @param {number} [schedulePeriodId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [weekNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignmentsEmployeeScheduleGet(departmentId?: number, facilityId?: number, positionIds?: Array<number>, search?: string, schedulePeriodId?: number, page?: number, pageSize?: number, weekNumber?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCentricViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsEmployeeScheduleGet(departmentId, facilityId, positionIds, search, schedulePeriodId, page, pageSize, weekNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [schedulePeriodId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsEmployeeTotalBudgetsGet(departmentId?: number, facilityId?: number, schedulePeriodId?: number, positionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeCentricBudgetTableShiftType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsEmployeeTotalBudgetsGet(departmentId, facilityId, schedulePeriodId, positionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsIntegrationRetriesGet(days?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsIntegrationRetriesGet(days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsIntegrationStatusGet(startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfDictionaryOfAssignmentIntegrationErrorsAndListOfAssignmentIntegrationStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsIntegrationStatusGet(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {string} [startDateTime] 
         * @param {string} [endDateTime] 
         * @param {string} [searchParam] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<EmployerType>} [employerType] 
         * @param {Array<SchedulerOvertimeType>} [overTime] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {number} [openingTemplateId] 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsInterestedEmployeeGet(positionId?: number, startDateTime?: string, endDateTime?: string, searchParam?: string, page?: number, pageSize?: number, employerType?: Array<EmployerType>, overTime?: Array<SchedulerOvertimeType>, orderBy?: AvailableEmployeesOrderBy, openingTemplateId?: number, facilityId?: number, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfPageModelOfGetAvailableEmployeesByPositionAndDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsInterestedEmployeeGet(positionId, startDateTime, endDateTime, searchParam, page, pageSize, employerType, overTime, orderBy, openingTemplateId, facilityId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {string} [startDateTime] 
         * @param {string} [endDateTime] 
         * @param {string} [searchParam] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<EmployerType>} [employerType] 
         * @param {Array<SchedulerOvertimeType>} [overTime] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {number} [openingTemplateId] 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsNotifiedEmployeeGet(positionId?: number, startDateTime?: string, endDateTime?: string, searchParam?: string, page?: number, pageSize?: number, employerType?: Array<EmployerType>, overTime?: Array<SchedulerOvertimeType>, orderBy?: AvailableEmployeesOrderBy, openingTemplateId?: number, facilityId?: number, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfPageModelOfGetAvailableEmployeesByPositionAndDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsNotifiedEmployeeGet(positionId, startDateTime, endDateTime, searchParam, page, pageSize, employerType, overTime, orderBy, openingTemplateId, facilityId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignmentsPositionDetailsGet(departmentId?: number, positionId?: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfGetPositionDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsPositionDetailsGet(departmentId, positionId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsRetryIntegrationAssignmentIdGet(assignmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsRetryIntegrationAssignmentIdGet(assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignmentsRetryIntegrationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsRetryIntegrationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsScheduleCalendarAbsencesGet(schedulePeriodId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleCalendarAbsencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsScheduleCalendarAbsencesGet(schedulePeriodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {ScheduleCalendarGroupBy} [groupBy] 
         * @param {number} [shiftTypeId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsScheduleCalendarGet(schedulePeriodId?: number, groupBy?: ScheduleCalendarGroupBy, shiftTypeId?: number, facilityId?: number, positionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleCalendarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsScheduleCalendarGet(schedulePeriodId, groupBy, shiftTypeId, facilityId, positionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ScheduleCalendarRequest} [scheduleCalendarRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsScheduleCalendarPost(scheduleCalendarRequest?: ScheduleCalendarRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleCalendarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsScheduleCalendarPost(scheduleCalendarRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsSchedulerViewsStartDateGet(departmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyViewStartDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsSchedulerViewsStartDateGet(departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [schedulePeriodId] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsShiftBudgetsPerEmployeeScheduleGet(departmentId?: number, facilityId?: number, schedulePeriodId?: number, positionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetsByOpening>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsShiftBudgetsPerEmployeeScheduleGet(departmentId, facilityId, schedulePeriodId, positionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *   This endpoint intentionally does <b>not</b> accept or flow a System.Threading.CancellationToken              to the transactional work. The transaction is executed with System.Threading.CancellationToken.None to avoid              partial execution if the HTTP request is aborted (e.g., client disconnect). Once started, the core write              operation is allowed to complete deterministically.    Post-create operations are executed asynchronously via Hangfire using the authenticated facility context              (OpenShifts.WebApi.Controllers.Scheduler.BaseController.FacilityId), and therefore are decoupled from the HTTP request lifecycle.
         * @summary Creates a new employee assignment (v2) within a single database transaction, then enqueues  post-create processing as a Hangfire background job.
         * @param {AddAssignmentRequestV2} [addAssignmentRequestV2] The assignment creation request payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsV2AddAssignmentPost(addAssignmentRequestV2?: AddAssignmentRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV2AddAssignmentPost(addAssignmentRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get assignments along with empty assignments for empty split assignment slots
         * @param {number} [openingTemplateId] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignmentsV2AssignedEmployeeGet(openingTemplateId?: number, openingTemplateDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfListOfAllocatedEmployeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV2AssignedEmployeeGet(openingTemplateId, openingTemplateDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Same as \"v2/assigned-employee\" or \"v3/assigned-employee\" but retrieves data for multiple opening templates
         * @param {Array<number>} [openingTemplateIds] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsV2AssignedEmployeeMultipleShiftsGet(openingTemplateIds?: Array<number>, openingTemplateDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfDictionaryOfInt64AndListOfAllocatedEmployeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV2AssignedEmployeeMultipleShiftsGet(openingTemplateIds, openingTemplateDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} assignmentId 
         * @param {UpdateAssignmentDto} [updateAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsV2AssignmentIdPut(assignmentId: number, updateAssignmentDto?: UpdateAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV2AssignmentIdPut(assignmentId, updateAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [unitIds] 
         * @param {Array<number>} [positionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsV2DailyviewGet(date: string, departmentId?: number, facilityId?: number, unitIds?: Array<number>, positionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewDailyStaffingLevelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV2DailyviewGet(date, departmentId, facilityId, unitIds, positionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionIds] 
         * @param {string} [search] 
         * @param {number} [schedulePeriodId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [weekNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsV2EmployeeScheduleGet(departmentId?: number, facilityId?: number, positionIds?: Array<number>, search?: string, schedulePeriodId?: number, page?: number, pageSize?: number, weekNumber?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV2EmployeeScheduleGet(departmentId, facilityId, positionIds, search, schedulePeriodId, page, pageSize, weekNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get assignments along with empty assignments for empty split assignment slots along with placeholders
         * @param {number} [openingTemplateId] 
         * @param {string} [openingTemplateDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsV3AssignedEmployeeGet(openingTemplateId?: number, openingTemplateDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocatedEmployeeAndAbsencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV3AssignedEmployeeGet(openingTemplateId, openingTemplateDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {string} [startDateTime] 
         * @param {string} [endDateTime] 
         * @param {string} [searchParam] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<EmployerType>} [employerType] 
         * @param {Array<SchedulerOvertimeType>} [overTime] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {number} [openingTemplateId] 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsV3AvailableEmployeeGet(positionId?: number, startDateTime?: string, endDateTime?: string, searchParam?: string, page?: number, pageSize?: number, employerType?: Array<EmployerType>, overTime?: Array<SchedulerOvertimeType>, orderBy?: AvailableEmployeesOrderBy, openingTemplateId?: number, facilityId?: number, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfPageModelOfGetAvailableEmployeesByPositionAndDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsV3AvailableEmployeeGet(positionId, startDateTime, endDateTime, searchParam, page, pageSize, employerType, overTime, orderBy, openingTemplateId, facilityId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ManageSchedulesApi - factory interface
 * @export
 */
export const ManageSchedulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManageSchedulesApiFp(configuration)
    return {
        /**
         * This should be removed once front end calls the replacement: Absences/AbsenceReasons/Scheduler.  Just need to wait until the newer one is published in order to modify the front end.
         * @summary Gets absence reasons for the scheduler (original endpoint).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAbsenceReasonsGet(options?: AxiosRequestConfig): AxiosPromise<Array<ScheduleStatusTypeResponse>> {
            return localVarFp.assignmentsAbsenceReasonsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsAddAssignmentPost(requestParameters: ManageSchedulesApiAssignmentsAddAssignmentPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ViewAssignmentDto> {
            return localVarFp.assignmentsAddAssignmentPost(requestParameters.addAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. The lists a manager picks  from already exclude those employees, so this fires on a direct call or a page loaded before  a work pattern changed. SPD-5838 covers surfacing it.
         * @param {ManageSchedulesApiAssignmentsAssignEmployeePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignEmployeePost(requestParameters: ManageSchedulesApiAssignmentsAssignEmployeePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewAssignmentDto> {
            return localVarFp.assignmentsAssignEmployeePost(requestParameters.createAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. SPD-5838 covers surfacing  it.    Unlike the sibling actions, this one IS reachable from the screen rather than only from a  direct call or a stale page. Find Staff\'s tabs exclude these employees, but the website\'s  Open Shifts page lists its own through `GET OpenShift/posted-shift-employees`  (`OpeningService.GetOpenShiftEmployeesWithOpeningTemplates`), which applies no work  pattern test — so anyone auto-post notified BEFORE this release while on Simple Scheduling  or with no pattern still shows there as Notified, and ticking one refuses the whole  selection. Auto-post adds nobody new to that group from release, so it only shrinks.  Not filtered there: the query joins two keyless views, so no test can reach the predicate.
         * @param {ManageSchedulesApiAssignmentsAssignOpenshiftsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignOpenshiftsPost(requestParameters: ManageSchedulesApiAssignmentsAssignOpenshiftsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignmentsAssignOpenshiftsPost(requestParameters.assignSelectedOpenshiftsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsAssignedEmployeeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsAssignedEmployeeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfAllocatedEmployeListResponse> {
            return localVarFp.assignmentsAssignedEmployeeGet(requestParameters.openingTemplateId, requestParameters.openingTemplateDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdDelete(requestParameters: ManageSchedulesApiAssignmentsAssignmentIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignmentsAssignmentIdDelete(requestParameters.assignmentId, requestParameters.createAbsenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Use v2/{assignmentId}
         * @param {ManageSchedulesApiAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdPut(requestParameters: ManageSchedulesApiAssignmentsAssignmentIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewAssignmentDto> {
            return localVarFp.assignmentsAssignmentIdPut(requestParameters.assignmentId, requestParameters.updateAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsDailyviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDailyviewGet(requestParameters: ManageSchedulesApiAssignmentsDailyviewGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfDailyViewResponse> {
            return localVarFp.assignmentsDailyviewGet(requestParameters.departmentId, requestParameters.date, requestParameters.facilityId, requestParameters.positionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsDailyviewSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDailyviewSummaryGet(requestParameters: ManageSchedulesApiAssignmentsDailyviewSummaryGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<DailyViewSummaryResponse> {
            return localVarFp.assignmentsDailyviewSummaryGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDefectiveOpeningInstanceGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.assignmentsDefectiveOpeningInstanceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsDisplaySchedulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDisplaySchedulesGet(requestParameters: ManageSchedulesApiAssignmentsDisplaySchedulesGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfSchedulePositionResponse> {
            return localVarFp.assignmentsDisplaySchedulesGet(requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsDisplaySchedulesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsDisplaySchedulesPost(requestParameters: ManageSchedulesApiAssignmentsDisplaySchedulesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfSchedulePositionResponse> {
            return localVarFp.assignmentsDisplaySchedulesPost(requestParameters.getAvailableSchedulesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsEmployeeAbsenceAbsenceIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsenceAbsenceIdDelete(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsenceAbsenceIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignmentsEmployeeAbsenceAbsenceIdDelete(requestParameters.absenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsEmployeeAbsencePlannedAbsenceIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsencePlannedAbsenceIdDelete(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsencePlannedAbsenceIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<DeletePlannedAbsenceResponse> {
            return localVarFp.assignmentsEmployeeAbsencePlannedAbsenceIdDelete(requestParameters.absenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsEmployeeAbsencePlannedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsencePlannedGet(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsencePlannedGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewAbsenceDto> {
            return localVarFp.assignmentsEmployeeAbsencePlannedGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsEmployeeAbsencePlannedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeAbsencePlannedPost(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsencePlannedPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewAbsenceDto> {
            return localVarFp.assignmentsEmployeeAbsencePlannedPost(requestParameters.createAbsenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsEmployeeScheduleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsEmployeeScheduleGet(requestParameters: ManageSchedulesApiAssignmentsEmployeeScheduleGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeCentricViewResponse> {
            return localVarFp.assignmentsEmployeeScheduleGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionIds, requestParameters.search, requestParameters.schedulePeriodId, requestParameters.page, requestParameters.pageSize, requestParameters.weekNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsEmployeeTotalBudgetsGet(requestParameters: ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeCentricBudgetTableShiftType>> {
            return localVarFp.assignmentsEmployeeTotalBudgetsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.schedulePeriodId, requestParameters.positionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsIntegrationRetriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsIntegrationRetriesGet(requestParameters: ManageSchedulesApiAssignmentsIntegrationRetriesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<LogEntry>> {
            return localVarFp.assignmentsIntegrationRetriesGet(requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsIntegrationStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsIntegrationStatusGet(requestParameters: ManageSchedulesApiAssignmentsIntegrationStatusGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfDictionaryOfAssignmentIntegrationErrorsAndListOfAssignmentIntegrationStatus> {
            return localVarFp.assignmentsIntegrationStatusGet(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsInterestedEmployeeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsInterestedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsInterestedEmployeeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfPageModelOfGetAvailableEmployeesByPositionAndDatesResponse> {
            return localVarFp.assignmentsInterestedEmployeeGet(requestParameters.positionId, requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.searchParam, requestParameters.page, requestParameters.pageSize, requestParameters.employerType, requestParameters.overTime, requestParameters.orderBy, requestParameters.openingTemplateId, requestParameters.facilityId, requestParameters.departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsNotifiedEmployeeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsNotifiedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsNotifiedEmployeeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfPageModelOfGetAvailableEmployeesByPositionAndDatesResponse> {
            return localVarFp.assignmentsNotifiedEmployeeGet(requestParameters.positionId, requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.searchParam, requestParameters.page, requestParameters.pageSize, requestParameters.employerType, requestParameters.overTime, requestParameters.orderBy, requestParameters.openingTemplateId, requestParameters.facilityId, requestParameters.departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsPositionDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsPositionDetailsGet(requestParameters: ManageSchedulesApiAssignmentsPositionDetailsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfGetPositionDetailsResponse> {
            return localVarFp.assignmentsPositionDetailsGet(requestParameters.departmentId, requestParameters.positionId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsRetryIntegrationAssignmentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsRetryIntegrationAssignmentIdGet(requestParameters: ManageSchedulesApiAssignmentsRetryIntegrationAssignmentIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.assignmentsRetryIntegrationAssignmentIdGet(requestParameters.assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsRetryIntegrationGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.assignmentsRetryIntegrationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsScheduleCalendarAbsencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsScheduleCalendarAbsencesGet(requestParameters: ManageSchedulesApiAssignmentsScheduleCalendarAbsencesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ScheduleCalendarAbsencesResponse> {
            return localVarFp.assignmentsScheduleCalendarAbsencesGet(requestParameters.schedulePeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsScheduleCalendarGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsScheduleCalendarGet(requestParameters: ManageSchedulesApiAssignmentsScheduleCalendarGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ScheduleCalendarResponse> {
            return localVarFp.assignmentsScheduleCalendarGet(requestParameters.schedulePeriodId, requestParameters.groupBy, requestParameters.shiftTypeId, requestParameters.facilityId, requestParameters.positionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsScheduleCalendarPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsScheduleCalendarPost(requestParameters: ManageSchedulesApiAssignmentsScheduleCalendarPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ScheduleCalendarResponse> {
            return localVarFp.assignmentsScheduleCalendarPost(requestParameters.scheduleCalendarRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsSchedulerViewsStartDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsSchedulerViewsStartDateGet(requestParameters: ManageSchedulesApiAssignmentsSchedulerViewsStartDateGetRequest, options?: AxiosRequestConfig): AxiosPromise<DailyViewStartDateResponse> {
            return localVarFp.assignmentsSchedulerViewsStartDateGet(requestParameters.departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsShiftBudgetsPerEmployeeScheduleGet(requestParameters: ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BudgetsByOpening> {
            return localVarFp.assignmentsShiftBudgetsPerEmployeeScheduleGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.schedulePeriodId, requestParameters.positionIds, options).then((request) => request(axios, basePath));
        },
        /**
         *   This endpoint intentionally does <b>not</b> accept or flow a System.Threading.CancellationToken              to the transactional work. The transaction is executed with System.Threading.CancellationToken.None to avoid              partial execution if the HTTP request is aborted (e.g., client disconnect). Once started, the core write              operation is allowed to complete deterministically.    Post-create operations are executed asynchronously via Hangfire using the authenticated facility context              (OpenShifts.WebApi.Controllers.Scheduler.BaseController.FacilityId), and therefore are decoupled from the HTTP request lifecycle.
         * @summary Creates a new employee assignment (v2) within a single database transaction, then enqueues  post-create processing as a Hangfire background job.
         * @param {ManageSchedulesApiAssignmentsV2AddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2AddAssignmentPost(requestParameters: ManageSchedulesApiAssignmentsV2AddAssignmentPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ViewAssignmentDto> {
            return localVarFp.assignmentsV2AddAssignmentPost(requestParameters.addAssignmentRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get assignments along with empty assignments for empty split assignment slots
         * @param {ManageSchedulesApiAssignmentsV2AssignedEmployeeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignmentsV2AssignedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsV2AssignedEmployeeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfListOfAllocatedEmployeListResponse> {
            return localVarFp.assignmentsV2AssignedEmployeeGet(requestParameters.openingTemplateId, requestParameters.openingTemplateDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Same as \"v2/assigned-employee\" or \"v3/assigned-employee\" but retrieves data for multiple opening templates
         * @param {ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2AssignedEmployeeMultipleShiftsGet(requestParameters: ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfDictionaryOfInt64AndListOfAllocatedEmployeListResponse> {
            return localVarFp.assignmentsV2AssignedEmployeeMultipleShiftsGet(requestParameters.openingTemplateIds, requestParameters.openingTemplateDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsV2AssignmentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2AssignmentIdPut(requestParameters: ManageSchedulesApiAssignmentsV2AssignmentIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<ViewAssignmentDto> {
            return localVarFp.assignmentsV2AssignmentIdPut(requestParameters.assignmentId, requestParameters.updateAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsV2DailyviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2DailyviewGet(requestParameters: ManageSchedulesApiAssignmentsV2DailyviewGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewDailyStaffingLevelsResponse> {
            return localVarFp.assignmentsV2DailyviewGet(requestParameters.date, requestParameters.departmentId, requestParameters.facilityId, requestParameters.unitIds, requestParameters.positionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsV2EmployeeScheduleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV2EmployeeScheduleGet(requestParameters: ManageSchedulesApiAssignmentsV2EmployeeScheduleGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<WeeklyView> {
            return localVarFp.assignmentsV2EmployeeScheduleGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionIds, requestParameters.search, requestParameters.schedulePeriodId, requestParameters.page, requestParameters.pageSize, requestParameters.weekNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get assignments along with empty assignments for empty split assignment slots along with placeholders
         * @param {ManageSchedulesApiAssignmentsV3AssignedEmployeeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV3AssignedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsV3AssignedEmployeeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AllocatedEmployeeAndAbsencesResponse> {
            return localVarFp.assignmentsV3AssignedEmployeeGet(requestParameters.openingTemplateId, requestParameters.openingTemplateDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManageSchedulesApiAssignmentsV3AvailableEmployeeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsV3AvailableEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsV3AvailableEmployeeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfPageModelOfGetAvailableEmployeesByPositionAndDatesResponse> {
            return localVarFp.assignmentsV3AvailableEmployeeGet(requestParameters.positionId, requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.searchParam, requestParameters.page, requestParameters.pageSize, requestParameters.employerType, requestParameters.overTime, requestParameters.orderBy, requestParameters.openingTemplateId, requestParameters.facilityId, requestParameters.departmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assignmentsAddAssignmentPost operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsAddAssignmentPostRequest
 */
export interface ManageSchedulesApiAssignmentsAddAssignmentPostRequest {
    /**
     * 
     * @type {AddAssignmentRequest}
     * @memberof ManageSchedulesApiAssignmentsAddAssignmentPost
     */
    readonly addAssignmentRequest?: AddAssignmentRequest
}

/**
 * Request parameters for assignmentsAssignEmployeePost operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsAssignEmployeePostRequest
 */
export interface ManageSchedulesApiAssignmentsAssignEmployeePostRequest {
    /**
     * 
     * @type {CreateAssignmentDto}
     * @memberof ManageSchedulesApiAssignmentsAssignEmployeePost
     */
    readonly createAssignmentDto?: CreateAssignmentDto
}

/**
 * Request parameters for assignmentsAssignOpenshiftsPost operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsAssignOpenshiftsPostRequest
 */
export interface ManageSchedulesApiAssignmentsAssignOpenshiftsPostRequest {
    /**
     * 
     * @type {AssignSelectedOpenshiftsRequest}
     * @memberof ManageSchedulesApiAssignmentsAssignOpenshiftsPost
     */
    readonly assignSelectedOpenshiftsRequest?: AssignSelectedOpenshiftsRequest
}

/**
 * Request parameters for assignmentsAssignedEmployeeGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsAssignedEmployeeGetRequest
 */
export interface ManageSchedulesApiAssignmentsAssignedEmployeeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsAssignedEmployeeGet
     */
    readonly openingTemplateId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsAssignedEmployeeGet
     */
    readonly openingTemplateDate?: string
}

/**
 * Request parameters for assignmentsAssignmentIdDelete operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsAssignmentIdDeleteRequest
 */
export interface ManageSchedulesApiAssignmentsAssignmentIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsAssignmentIdDelete
     */
    readonly assignmentId: number

    /**
     * 
     * @type {CreateAbsenceDto}
     * @memberof ManageSchedulesApiAssignmentsAssignmentIdDelete
     */
    readonly createAbsenceDto?: CreateAbsenceDto
}

/**
 * Request parameters for assignmentsAssignmentIdPut operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsAssignmentIdPutRequest
 */
export interface ManageSchedulesApiAssignmentsAssignmentIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsAssignmentIdPut
     */
    readonly assignmentId: number

    /**
     * 
     * @type {UpdateAssignmentDto}
     * @memberof ManageSchedulesApiAssignmentsAssignmentIdPut
     */
    readonly updateAssignmentDto?: UpdateAssignmentDto
}

/**
 * Request parameters for assignmentsDailyviewGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsDailyviewGetRequest
 */
export interface ManageSchedulesApiAssignmentsDailyviewGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsDailyviewGet
     */
    readonly departmentId: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsDailyviewGet
     */
    readonly date: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsDailyviewGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsDailyviewGet
     */
    readonly positionIds?: Array<number>
}

/**
 * Request parameters for assignmentsDailyviewSummaryGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsDailyviewSummaryGetRequest
 */
export interface ManageSchedulesApiAssignmentsDailyviewSummaryGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsDailyviewSummaryGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsDailyviewSummaryGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsDailyviewSummaryGet
     */
    readonly date?: string
}

/**
 * Request parameters for assignmentsDisplaySchedulesGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsDisplaySchedulesGetRequest
 */
export interface ManageSchedulesApiAssignmentsDisplaySchedulesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsDisplaySchedulesGet
     */
    readonly startDateTime: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsDisplaySchedulesGet
     */
    readonly endDateTime: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsDisplaySchedulesGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsDisplaySchedulesGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsDisplaySchedulesGet
     */
    readonly positionIds?: Array<number>
}

/**
 * Request parameters for assignmentsDisplaySchedulesPost operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsDisplaySchedulesPostRequest
 */
export interface ManageSchedulesApiAssignmentsDisplaySchedulesPostRequest {
    /**
     * 
     * @type {GetAvailableSchedulesRequest}
     * @memberof ManageSchedulesApiAssignmentsDisplaySchedulesPost
     */
    readonly getAvailableSchedulesRequest?: GetAvailableSchedulesRequest
}

/**
 * Request parameters for assignmentsEmployeeAbsenceAbsenceIdDelete operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsEmployeeAbsenceAbsenceIdDeleteRequest
 */
export interface ManageSchedulesApiAssignmentsEmployeeAbsenceAbsenceIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeAbsenceAbsenceIdDelete
     */
    readonly absenceId: number
}

/**
 * Request parameters for assignmentsEmployeeAbsencePlannedAbsenceIdDelete operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsEmployeeAbsencePlannedAbsenceIdDeleteRequest
 */
export interface ManageSchedulesApiAssignmentsEmployeeAbsencePlannedAbsenceIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeAbsencePlannedAbsenceIdDelete
     */
    readonly absenceId: number
}

/**
 * Request parameters for assignmentsEmployeeAbsencePlannedGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsEmployeeAbsencePlannedGetRequest
 */
export interface ManageSchedulesApiAssignmentsEmployeeAbsencePlannedGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeAbsencePlannedGet
     */
    readonly employeeId?: number
}

/**
 * Request parameters for assignmentsEmployeeAbsencePlannedPost operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsEmployeeAbsencePlannedPostRequest
 */
export interface ManageSchedulesApiAssignmentsEmployeeAbsencePlannedPostRequest {
    /**
     * 
     * @type {CreateAbsenceDto}
     * @memberof ManageSchedulesApiAssignmentsEmployeeAbsencePlannedPost
     */
    readonly createAbsenceDto?: CreateAbsenceDto
}

/**
 * Request parameters for assignmentsEmployeeScheduleGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsEmployeeScheduleGetRequest
 */
export interface ManageSchedulesApiAssignmentsEmployeeScheduleGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly positionIds?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly schedulePeriodId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeScheduleGet
     */
    readonly weekNumber?: number
}

/**
 * Request parameters for assignmentsEmployeeTotalBudgetsGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGetRequest
 */
export interface ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGet
     */
    readonly schedulePeriodId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGet
     */
    readonly positionIds?: Array<number>
}

/**
 * Request parameters for assignmentsIntegrationRetriesGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsIntegrationRetriesGetRequest
 */
export interface ManageSchedulesApiAssignmentsIntegrationRetriesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsIntegrationRetriesGet
     */
    readonly days?: number
}

/**
 * Request parameters for assignmentsIntegrationStatusGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsIntegrationStatusGetRequest
 */
export interface ManageSchedulesApiAssignmentsIntegrationStatusGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsIntegrationStatusGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsIntegrationStatusGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for assignmentsInterestedEmployeeGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsInterestedEmployeeGetRequest
 */
export interface ManageSchedulesApiAssignmentsInterestedEmployeeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly startDateTime?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly endDateTime?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly searchParam?: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<EmployerType>}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly employerType?: Array<EmployerType>

    /**
     * 
     * @type {Array<SchedulerOvertimeType>}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly overTime?: Array<SchedulerOvertimeType>

    /**
     * 
     * @type {AvailableEmployeesOrderBy}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly orderBy?: AvailableEmployeesOrderBy

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly openingTemplateId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsInterestedEmployeeGet
     */
    readonly departmentId?: number
}

/**
 * Request parameters for assignmentsNotifiedEmployeeGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsNotifiedEmployeeGetRequest
 */
export interface ManageSchedulesApiAssignmentsNotifiedEmployeeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly startDateTime?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly endDateTime?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly searchParam?: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<EmployerType>}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly employerType?: Array<EmployerType>

    /**
     * 
     * @type {Array<SchedulerOvertimeType>}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly overTime?: Array<SchedulerOvertimeType>

    /**
     * 
     * @type {AvailableEmployeesOrderBy}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly orderBy?: AvailableEmployeesOrderBy

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly openingTemplateId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsNotifiedEmployeeGet
     */
    readonly departmentId?: number
}

/**
 * Request parameters for assignmentsPositionDetailsGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsPositionDetailsGetRequest
 */
export interface ManageSchedulesApiAssignmentsPositionDetailsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsPositionDetailsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsPositionDetailsGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsPositionDetailsGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsPositionDetailsGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for assignmentsRetryIntegrationAssignmentIdGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsRetryIntegrationAssignmentIdGetRequest
 */
export interface ManageSchedulesApiAssignmentsRetryIntegrationAssignmentIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsRetryIntegrationAssignmentIdGet
     */
    readonly assignmentId: number
}

/**
 * Request parameters for assignmentsScheduleCalendarAbsencesGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsScheduleCalendarAbsencesGetRequest
 */
export interface ManageSchedulesApiAssignmentsScheduleCalendarAbsencesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsScheduleCalendarAbsencesGet
     */
    readonly schedulePeriodId?: number
}

/**
 * Request parameters for assignmentsScheduleCalendarGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsScheduleCalendarGetRequest
 */
export interface ManageSchedulesApiAssignmentsScheduleCalendarGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsScheduleCalendarGet
     */
    readonly schedulePeriodId?: number

    /**
     * 
     * @type {ScheduleCalendarGroupBy}
     * @memberof ManageSchedulesApiAssignmentsScheduleCalendarGet
     */
    readonly groupBy?: ScheduleCalendarGroupBy

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsScheduleCalendarGet
     */
    readonly shiftTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsScheduleCalendarGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsScheduleCalendarGet
     */
    readonly positionIds?: Array<number>
}

/**
 * Request parameters for assignmentsScheduleCalendarPost operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsScheduleCalendarPostRequest
 */
export interface ManageSchedulesApiAssignmentsScheduleCalendarPostRequest {
    /**
     * 
     * @type {ScheduleCalendarRequest}
     * @memberof ManageSchedulesApiAssignmentsScheduleCalendarPost
     */
    readonly scheduleCalendarRequest?: ScheduleCalendarRequest
}

/**
 * Request parameters for assignmentsSchedulerViewsStartDateGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsSchedulerViewsStartDateGetRequest
 */
export interface ManageSchedulesApiAssignmentsSchedulerViewsStartDateGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsSchedulerViewsStartDateGet
     */
    readonly departmentId: number
}

/**
 * Request parameters for assignmentsShiftBudgetsPerEmployeeScheduleGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGetRequest
 */
export interface ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGet
     */
    readonly schedulePeriodId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGet
     */
    readonly positionIds?: Array<number>
}

/**
 * Request parameters for assignmentsV2AddAssignmentPost operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV2AddAssignmentPostRequest
 */
export interface ManageSchedulesApiAssignmentsV2AddAssignmentPostRequest {
    /**
     * The assignment creation request payload.
     * @type {AddAssignmentRequestV2}
     * @memberof ManageSchedulesApiAssignmentsV2AddAssignmentPost
     */
    readonly addAssignmentRequestV2?: AddAssignmentRequestV2
}

/**
 * Request parameters for assignmentsV2AssignedEmployeeGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV2AssignedEmployeeGetRequest
 */
export interface ManageSchedulesApiAssignmentsV2AssignedEmployeeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2AssignedEmployeeGet
     */
    readonly openingTemplateId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV2AssignedEmployeeGet
     */
    readonly openingTemplateDate?: string
}

/**
 * Request parameters for assignmentsV2AssignedEmployeeMultipleShiftsGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGetRequest
 */
export interface ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGetRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGet
     */
    readonly openingTemplateIds?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGet
     */
    readonly openingTemplateDate?: string
}

/**
 * Request parameters for assignmentsV2AssignmentIdPut operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV2AssignmentIdPutRequest
 */
export interface ManageSchedulesApiAssignmentsV2AssignmentIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2AssignmentIdPut
     */
    readonly assignmentId: number

    /**
     * 
     * @type {UpdateAssignmentDto}
     * @memberof ManageSchedulesApiAssignmentsV2AssignmentIdPut
     */
    readonly updateAssignmentDto?: UpdateAssignmentDto
}

/**
 * Request parameters for assignmentsV2DailyviewGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV2DailyviewGetRequest
 */
export interface ManageSchedulesApiAssignmentsV2DailyviewGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV2DailyviewGet
     */
    readonly date: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2DailyviewGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2DailyviewGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsV2DailyviewGet
     */
    readonly unitIds?: Array<number>

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsV2DailyviewGet
     */
    readonly positionIds?: Array<number>
}

/**
 * Request parameters for assignmentsV2EmployeeScheduleGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV2EmployeeScheduleGetRequest
 */
export interface ManageSchedulesApiAssignmentsV2EmployeeScheduleGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly positionIds?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly schedulePeriodId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV2EmployeeScheduleGet
     */
    readonly weekNumber?: number
}

/**
 * Request parameters for assignmentsV3AssignedEmployeeGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV3AssignedEmployeeGetRequest
 */
export interface ManageSchedulesApiAssignmentsV3AssignedEmployeeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV3AssignedEmployeeGet
     */
    readonly openingTemplateId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV3AssignedEmployeeGet
     */
    readonly openingTemplateDate?: string
}

/**
 * Request parameters for assignmentsV3AvailableEmployeeGet operation in ManageSchedulesApi.
 * @export
 * @interface ManageSchedulesApiAssignmentsV3AvailableEmployeeGetRequest
 */
export interface ManageSchedulesApiAssignmentsV3AvailableEmployeeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly startDateTime?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly endDateTime?: string

    /**
     * 
     * @type {string}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly searchParam?: string

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<EmployerType>}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly employerType?: Array<EmployerType>

    /**
     * 
     * @type {Array<SchedulerOvertimeType>}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly overTime?: Array<SchedulerOvertimeType>

    /**
     * 
     * @type {AvailableEmployeesOrderBy}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly orderBy?: AvailableEmployeesOrderBy

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly openingTemplateId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ManageSchedulesApiAssignmentsV3AvailableEmployeeGet
     */
    readonly departmentId?: number
}

/**
 * ManageSchedulesApi - object-oriented interface
 * @export
 * @class ManageSchedulesApi
 * @extends {BaseAPI}
 */
export class ManageSchedulesApi extends BaseAPI {
    /**
     * This should be removed once front end calls the replacement: Absences/AbsenceReasons/Scheduler.  Just need to wait until the newer one is published in order to modify the front end.
     * @summary Gets absence reasons for the scheduler (original endpoint).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsAbsenceReasonsGet(options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsAbsenceReasonsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsAddAssignmentPost(requestParameters: ManageSchedulesApiAssignmentsAddAssignmentPostRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsAddAssignmentPost(requestParameters.addAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. The lists a manager picks  from already exclude those employees, so this fires on a direct call or a page loaded before  a work pattern changed. SPD-5838 covers surfacing it.
     * @param {ManageSchedulesApiAssignmentsAssignEmployeePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsAssignEmployeePost(requestParameters: ManageSchedulesApiAssignmentsAssignEmployeePostRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsAssignEmployeePost(requestParameters.createAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPD-5132: answers 400 when the employee\'s work pattern on the assignment\'s date is not one  of the four Scheduler types, so the scheduler does not work them. SPD-5838 covers surfacing  it.    Unlike the sibling actions, this one IS reachable from the screen rather than only from a  direct call or a stale page. Find Staff\'s tabs exclude these employees, but the website\'s  Open Shifts page lists its own through `GET OpenShift/posted-shift-employees`  (`OpeningService.GetOpenShiftEmployeesWithOpeningTemplates`), which applies no work  pattern test — so anyone auto-post notified BEFORE this release while on Simple Scheduling  or with no pattern still shows there as Notified, and ticking one refuses the whole  selection. Auto-post adds nobody new to that group from release, so it only shrinks.  Not filtered there: the query joins two keyless views, so no test can reach the predicate.
     * @param {ManageSchedulesApiAssignmentsAssignOpenshiftsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsAssignOpenshiftsPost(requestParameters: ManageSchedulesApiAssignmentsAssignOpenshiftsPostRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsAssignOpenshiftsPost(requestParameters.assignSelectedOpenshiftsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsAssignedEmployeeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsAssignedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsAssignedEmployeeGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsAssignedEmployeeGet(requestParameters.openingTemplateId, requestParameters.openingTemplateDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsAssignmentIdDelete(requestParameters: ManageSchedulesApiAssignmentsAssignmentIdDeleteRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsAssignmentIdDelete(requestParameters.assignmentId, requestParameters.createAbsenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Use v2/{assignmentId}
     * @param {ManageSchedulesApiAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsAssignmentIdPut(requestParameters: ManageSchedulesApiAssignmentsAssignmentIdPutRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsAssignmentIdPut(requestParameters.assignmentId, requestParameters.updateAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsDailyviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsDailyviewGet(requestParameters: ManageSchedulesApiAssignmentsDailyviewGetRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsDailyviewGet(requestParameters.departmentId, requestParameters.date, requestParameters.facilityId, requestParameters.positionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsDailyviewSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsDailyviewSummaryGet(requestParameters: ManageSchedulesApiAssignmentsDailyviewSummaryGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsDailyviewSummaryGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsDefectiveOpeningInstanceGet(options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsDefectiveOpeningInstanceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsDisplaySchedulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsDisplaySchedulesGet(requestParameters: ManageSchedulesApiAssignmentsDisplaySchedulesGetRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsDisplaySchedulesGet(requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsDisplaySchedulesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsDisplaySchedulesPost(requestParameters: ManageSchedulesApiAssignmentsDisplaySchedulesPostRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsDisplaySchedulesPost(requestParameters.getAvailableSchedulesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsEmployeeAbsenceAbsenceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsEmployeeAbsenceAbsenceIdDelete(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsenceAbsenceIdDeleteRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsEmployeeAbsenceAbsenceIdDelete(requestParameters.absenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsEmployeeAbsencePlannedAbsenceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsEmployeeAbsencePlannedAbsenceIdDelete(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsencePlannedAbsenceIdDeleteRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsEmployeeAbsencePlannedAbsenceIdDelete(requestParameters.absenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsEmployeeAbsencePlannedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsEmployeeAbsencePlannedGet(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsencePlannedGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsEmployeeAbsencePlannedGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsEmployeeAbsencePlannedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsEmployeeAbsencePlannedPost(requestParameters: ManageSchedulesApiAssignmentsEmployeeAbsencePlannedPostRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsEmployeeAbsencePlannedPost(requestParameters.createAbsenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsEmployeeScheduleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsEmployeeScheduleGet(requestParameters: ManageSchedulesApiAssignmentsEmployeeScheduleGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsEmployeeScheduleGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionIds, requestParameters.search, requestParameters.schedulePeriodId, requestParameters.page, requestParameters.pageSize, requestParameters.weekNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsEmployeeTotalBudgetsGet(requestParameters: ManageSchedulesApiAssignmentsEmployeeTotalBudgetsGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsEmployeeTotalBudgetsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.schedulePeriodId, requestParameters.positionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsIntegrationRetriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsIntegrationRetriesGet(requestParameters: ManageSchedulesApiAssignmentsIntegrationRetriesGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsIntegrationRetriesGet(requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsIntegrationStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsIntegrationStatusGet(requestParameters: ManageSchedulesApiAssignmentsIntegrationStatusGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsIntegrationStatusGet(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsInterestedEmployeeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsInterestedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsInterestedEmployeeGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsInterestedEmployeeGet(requestParameters.positionId, requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.searchParam, requestParameters.page, requestParameters.pageSize, requestParameters.employerType, requestParameters.overTime, requestParameters.orderBy, requestParameters.openingTemplateId, requestParameters.facilityId, requestParameters.departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsNotifiedEmployeeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsNotifiedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsNotifiedEmployeeGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsNotifiedEmployeeGet(requestParameters.positionId, requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.searchParam, requestParameters.page, requestParameters.pageSize, requestParameters.employerType, requestParameters.overTime, requestParameters.orderBy, requestParameters.openingTemplateId, requestParameters.facilityId, requestParameters.departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsPositionDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsPositionDetailsGet(requestParameters: ManageSchedulesApiAssignmentsPositionDetailsGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsPositionDetailsGet(requestParameters.departmentId, requestParameters.positionId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsRetryIntegrationAssignmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsRetryIntegrationAssignmentIdGet(requestParameters: ManageSchedulesApiAssignmentsRetryIntegrationAssignmentIdGetRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsRetryIntegrationAssignmentIdGet(requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsRetryIntegrationGet(options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsRetryIntegrationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsScheduleCalendarAbsencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsScheduleCalendarAbsencesGet(requestParameters: ManageSchedulesApiAssignmentsScheduleCalendarAbsencesGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsScheduleCalendarAbsencesGet(requestParameters.schedulePeriodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsScheduleCalendarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsScheduleCalendarGet(requestParameters: ManageSchedulesApiAssignmentsScheduleCalendarGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsScheduleCalendarGet(requestParameters.schedulePeriodId, requestParameters.groupBy, requestParameters.shiftTypeId, requestParameters.facilityId, requestParameters.positionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsScheduleCalendarPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsScheduleCalendarPost(requestParameters: ManageSchedulesApiAssignmentsScheduleCalendarPostRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsScheduleCalendarPost(requestParameters.scheduleCalendarRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsSchedulerViewsStartDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsSchedulerViewsStartDateGet(requestParameters: ManageSchedulesApiAssignmentsSchedulerViewsStartDateGetRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsSchedulerViewsStartDateGet(requestParameters.departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsShiftBudgetsPerEmployeeScheduleGet(requestParameters: ManageSchedulesApiAssignmentsShiftBudgetsPerEmployeeScheduleGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsShiftBudgetsPerEmployeeScheduleGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.schedulePeriodId, requestParameters.positionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *   This endpoint intentionally does <b>not</b> accept or flow a System.Threading.CancellationToken              to the transactional work. The transaction is executed with System.Threading.CancellationToken.None to avoid              partial execution if the HTTP request is aborted (e.g., client disconnect). Once started, the core write              operation is allowed to complete deterministically.    Post-create operations are executed asynchronously via Hangfire using the authenticated facility context              (OpenShifts.WebApi.Controllers.Scheduler.BaseController.FacilityId), and therefore are decoupled from the HTTP request lifecycle.
     * @summary Creates a new employee assignment (v2) within a single database transaction, then enqueues  post-create processing as a Hangfire background job.
     * @param {ManageSchedulesApiAssignmentsV2AddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV2AddAssignmentPost(requestParameters: ManageSchedulesApiAssignmentsV2AddAssignmentPostRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV2AddAssignmentPost(requestParameters.addAssignmentRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get assignments along with empty assignments for empty split assignment slots
     * @param {ManageSchedulesApiAssignmentsV2AssignedEmployeeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV2AssignedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsV2AssignedEmployeeGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV2AssignedEmployeeGet(requestParameters.openingTemplateId, requestParameters.openingTemplateDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Same as \"v2/assigned-employee\" or \"v3/assigned-employee\" but retrieves data for multiple opening templates
     * @param {ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV2AssignedEmployeeMultipleShiftsGet(requestParameters: ManageSchedulesApiAssignmentsV2AssignedEmployeeMultipleShiftsGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV2AssignedEmployeeMultipleShiftsGet(requestParameters.openingTemplateIds, requestParameters.openingTemplateDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsV2AssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV2AssignmentIdPut(requestParameters: ManageSchedulesApiAssignmentsV2AssignmentIdPutRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV2AssignmentIdPut(requestParameters.assignmentId, requestParameters.updateAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsV2DailyviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV2DailyviewGet(requestParameters: ManageSchedulesApiAssignmentsV2DailyviewGetRequest, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV2DailyviewGet(requestParameters.date, requestParameters.departmentId, requestParameters.facilityId, requestParameters.unitIds, requestParameters.positionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsV2EmployeeScheduleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV2EmployeeScheduleGet(requestParameters: ManageSchedulesApiAssignmentsV2EmployeeScheduleGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV2EmployeeScheduleGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionIds, requestParameters.search, requestParameters.schedulePeriodId, requestParameters.page, requestParameters.pageSize, requestParameters.weekNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get assignments along with empty assignments for empty split assignment slots along with placeholders
     * @param {ManageSchedulesApiAssignmentsV3AssignedEmployeeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV3AssignedEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsV3AssignedEmployeeGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV3AssignedEmployeeGet(requestParameters.openingTemplateId, requestParameters.openingTemplateDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManageSchedulesApiAssignmentsV3AvailableEmployeeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageSchedulesApi
     */
    public assignmentsV3AvailableEmployeeGet(requestParameters: ManageSchedulesApiAssignmentsV3AvailableEmployeeGetRequest = {}, options?: AxiosRequestConfig) {
        return ManageSchedulesApiFp(this.configuration).assignmentsV3AvailableEmployeeGet(requestParameters.positionId, requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.searchParam, requestParameters.page, requestParameters.pageSize, requestParameters.employerType, requestParameters.overTime, requestParameters.orderBy, requestParameters.openingTemplateId, requestParameters.facilityId, requestParameters.departmentId, options).then((request) => request(this.axios, this.basePath));
    }
}
